// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * Browser-only implementation of the module's state. The browser esm variant will not load the commonjs state, so we do not need to share state between the two.
 */
export const state = {
    instrumenterImplementation: undefined,
};
//# sourceMappingURL=state-browser.mjs.map